export const FIREBASE_CONFIG = {
	API_KEY:             process.env.NEXT_PUBLIC_WASTIC_FIREBASE_API_KEY,
	APP_ID:              process.env.NEXT_PUBLIC_WASTIC_FIREBASE_APP_ID,
	AUTH_DOMAIN:         process.env.NEXT_PUBLIC_WASTIC_FIREBASE_AUTH_DOMAIN,
	MESSAGING_SENDER_ID: process.env.NEXT_PUBLIC_WASTIC_FIREBASE_MESSAGING_SENDER_ID,
	PROJECT_ID:          process.env.NEXT_PUBLIC_WASTIC_FIREBASE_PROJECT_ID,
	STORAGE_BUCKET:      process.env.NEXT_PUBLIC_WASTIC_FIREBASE_STORAGE_BUCKET,
};